<form [formGroup]="form" (submit)="submit()" a11yFocusTrap>
    <vwui-modal-header>
        <h2 a11yPageTitleLevel="2">{{ 'COMPONENT.change_project_type.title' | translate }}</h2>
    </vwui-modal-header>
    <vwui-modal-body a11yAutoFocus>
        <vwui-form-group label="{{ 'COMPONENT.change_project_type.projectTypeId' | translate }}" inputId="projectTypeId">
            <ng-select [items]="projectTypes()"
                       [selectOnTab]="true"
                       bindLabel="name"
                       bindValue="id"
                       labelForId="projectTypeId"
                       required="true"
                       placeholder="{{ 'COMPONENT.change_project_type.projectTypeId' | translate }}"
                       formControlName="projectTypeId"
            >
            </ng-select>
        </vwui-form-group>
    </vwui-modal-body>
    <vwui-modal-footer>
        <vwui-button class="is-light" (click)="modalRef.close()">
            {{ 'BUTTON.cancel' | translate }}
        </vwui-button>
        <vwui-button class="is-primary" [loading]="loading" (click)="submit()">
            {{ 'BUTTON.create' | translate }}
        </vwui-button>
    </vwui-modal-footer>
</form>
